import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { resolveSeo } from '@/seo/seoData';
import { applySeoMeta } from '@/seo/meta';
import { applyJsonLd, clearJsonLd } from '@/seo/jsonLd';

// Centralized, route-aware SEO/head manager. It restores or replaces all
// managed metadata on every route change so values never leak between routes.
export default function SeoManager() {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const lang = (i18n.language || 'en').split('-')[0];
    const seo = resolveSeo(location.pathname, lang);

    if (!seo) {
      // Non-indexable route (e.g. 404) — no SEO optimization.
      clearJsonLd();
      document.title = 'Page Not Found';
      return;
    }

    applySeoMeta(seo);
    applyJsonLd(seo);
  }, [location.pathname, i18n.language]);

  return null;
}